
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import { ResizeHelper } from '../../dev/utils/ResizeHelper';

export class RoadRageIntroView implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000, //Default 0x000000
            backgroundAlpha:0.4, //Default 0.4
            bulletColor:0xffffff, //Default 0xffffff

        },
        stampColor:0xFFFFFF
    };

    stampConfig:StampConfig = {
        volatility:Volatility.HIGH
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    private bg_WIDTH:number = 1680;
    private bg_HEIGHT:number = 1680;
    private localPages:SlideShowPage[];

    constructor() {}

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);

        imgLoader.add("introBg", "resources/images/intro/introBackground.jpg");

        imgLoader.add("page1", "resources/images/intro/Feature_1.png");
        imgLoader.add("page2", "resources/images/intro/Feature_2.png");
        imgLoader.add("page3", "resources/images/intro/Feature_3.png");
        imgLoader.add("page4", "resources/images/intro/Feature_4.png");
        imgLoader.add("border", "resources/images/intro/borderTile.png");
        imgLoader.add("logo", "resources/images/intro/logo.png");
        imgLoader.add("logoPortrait", "resources/images/intro/logo_portrait.png");


        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        // this.background = new PIXI.Container();
        // this.background.addChild(Helper.createBasicGraphic(0xDDDDDD,1,-this.bg_WIDTH/2,-this.bg_HEIGHT/2,this.bg_WIDTH,this.bg_HEIGHT));

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture("border"), 1680, 77);
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture("border"), 1680, 77);
        bottomSprite.anchor.set(0.5, 0.5);
        bottomSprite.scale.x = -1;
        bottomSprite.scale.y = -1;
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture("page1")),
            new SlideShowPage(ImgLoader.getImgTexture("page2")),
            new SlideShowPage(ImgLoader.getImgTexture("page3")),
            new SlideShowPage(ImgLoader.getImgTexture("page4"))
        ];
        this.localPages = this.pages.concat();
    }

    private updatePos(arr:SlideShowPage[]) {
        arr.forEach((p,i) => {
            if( i <= 3){
                p.pivot.set(-1360/4,0);
                const size:number = ResizeHelper.isLandscape ? 1 : 0.8;
                p.scale.set(size,size)
            }
        })
    }

    onResize():void {
        this.updatePos(this.localPages);
        (this.logo.children[0] as PIXI.Sprite).texture = ImgLoader.getImgTexture(ResizeHelper.isLandscape ? "logo" : "logoPortrait");
        (this.logo.children[0] as PIXI.Sprite).position.y = ResizeHelper.isLandscape ? 0 : - 140;
    }



}
